import { GET_CARRIERS } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {

        case GET_CARRIERS:
            return action.payload;

        default:
            return state;
    }
}